"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KSVMatchInfo = void 0;
class KSVMatchInfo {
    constructor(data) {
        this.matchId = data.smbMatchId;
        this.venue = data.smbLocation.smbLocationName;
    }
    static fromData(data) {
        return new KSVMatchInfo(Object.assign({}, data));
    }
}
exports.KSVMatchInfo = KSVMatchInfo;
